import React from "react";

export const CATEGORIES = {
  "Panadería y pastelería": { id: "1", rolId: "USUA", enable: true },
  "Aprende con nuestro portafolio": { id: "2", rolId: "USUA", enable: true },
  "Nuestras recetas": { id: "3", rolId: "USUA", enable: true },
  Levadura: { id: "4", rolId: "USUA", enable: true },
  Premezclas: { id: "5", rolId: "USUA", enable: true },
  Margarinas: { id: "6", rolId: "USUA", enable: true },
  Cremas: { id: "7", rolId: "USUA", enable: true },
  Complementos: { id: "8", rolId: "USUA", enable: true },
  Seminarios: { id: "9", rolId: "USUA", enable: true },
  "Expertos Fleischmann": { id: "10", rolId: "USUA", enable: true },
  "Experiencia Express": { id: "23", rolId: "USUA", enable: false },
  "Tips y Recomendaciones": { id: "25", rolId: "USUA", enable: true },
  "Tips y Recomendaciones": { id: "25", rolId: "USUA", enable: true },
  "Experto en ventas Fleischmann": { id: "27", rolId: "VENTA", enable: true },
};

const EXAMS = {
  Negocios: "1",
  "Cápsula Costo Fijos": "2",
  "Cápsula Punto de equilibrio": "7",
  "Salario propio": "14",
  "Trámites de empresa": "15",
};

export const urlToId = (uri) => {
  return CATEGORIES[uri];
};

export const ExamToId = (uri) => {
  return EXAMS[uri];
};
